import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  queryAnswers: [],
  fileTray: [],
  tableData: {},
  workspaceId: null,
  type: null,
  savingDocument: false,
  isEditable: false,
  editorContentLoaded: false,
  isTest: false,
  title: "",
};

export const fpAppV4Slice = createSlice({
  name: "fpAppV4",
  initialState: initialState,
  reducers: {
    updateFpAppV4Data: (state, action) => {
      // Check if we're switching to a different workspace
      const isSwitchingWorkspace =
        action.payload.workspaceId &&
        state.workspaceId &&
        action.payload.workspaceId !== state.workspaceId;

      if (isSwitchingWorkspace) {
        // When switching workspaces, clear workspace-specific data
        const newFpAppV4Data = {
          ...state,
          ...action.payload,
          // Clear workspace-specific data
          queries: undefined,
          queryAnswers: [],
          title: "",
          type: action.payload.type,
          editorContentLoaded: false,
          user_email: undefined,
          user_id: undefined,
          defaultQueryInputTree: undefined,
          defaultSelectedFileIds: undefined,
        };
        Object.assign(state, newFpAppV4Data);
      } else {
        // Normal update
        const newFpAppV4Data = {
          ...state,
          ...action.payload,
        };
        Object.assign(state, newFpAppV4Data);
      }
    },

    addQueryAnswer: (state, action) => {
      state.queryAnswers = [...state.queryAnswers, action.payload];
    },

    failOutboundQuery: (state, action) => {
      const { qid, error } = action.payload;
      const failedQuery = state.queryAnswers.find((qa) => qa.qid === qid);
      failedQuery.status = "failed";
      failedQuery.error = error;
    },

    updateWorkspaceQueries: (state, action) => {
      state.queries = {
        ...state.queries,
        ...action.payload,
      };
    },

    resetFpAppV4Data: (state) => {
      return initialState;
    },
  },
});

export const {
  updateFpAppV4Data,
  resetFpAppV4Data,
  addQueryAnswer,
  failOutboundQuery,
  updateWorkspaceQueries,
} = fpAppV4Slice.actions;

export default fpAppV4Slice.reducer;
